import { FaturaProfissionalAtendimentosListSearchComponent } from './FaturaProfissionalAtendimentosListSearchComponent'

export const FaturaProfissionalAtendimentosListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <FaturaProfissionalAtendimentosListSearchComponent />
  </div>
)
